import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const MobileBox = styled.div`
    position: fixed;
    bottom: 80px;
    
    right: 20px;
    
    cursor: pointer;
    
    display: grid;
    grid-template-rows: 45px 30px;
    justify-items: center;   
`;

const PcBox = styled(MobileBox)`
    transform: scale(1.2);
    right: 35px;
`;

export const DailyDealContainerBox = styledByDevice(PcBox, MobileBox);
